import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  loading?: boolean
}

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-b4l-blue text-white hover:bg-b4l-blue-dark disabled:bg-b4l-blue/50',
  secondary:
    'bg-b4l-surface text-b4l-text border border-b4l-border hover:bg-b4l-bg disabled:text-b4l-text-muted',
  danger: 'bg-b4l-red text-white hover:bg-b4l-red-dark disabled:bg-b4l-red/50',
  ghost: 'bg-transparent text-b4l-text hover:bg-b4l-bg',
}

export function Button({
  variant = 'primary',
  loading,
  disabled,
  children,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      /*
        `||`, nu `??`: un `disabled={false}` explicit (formularul e completat) lasa butonul activ in
        timpul cererii, iar un dublu-clic pe „Emite AWB si bon" pleca de doua ori (O4).
      */
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded px-3 py-2 text-sm font-medium transition disabled:cursor-not-allowed ${VARIANTS[variant]} ${className}`}
      {...rest}
    >
      {loading && (
        <span className="h-3 w-3 animate-spin rounded-full border-2 border-white/40 border-t-white" />
      )}
      {children}
    </button>
  )
}
